export default {
  toApiDate(d) {
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = (d.getDate()).toString().padStart(2, '0');
    const hours = (d.getHours()).toString().padStart(2, '0');
    const minutes = (d.getMinutes()).toString().padStart(2, '0');
    const sec = (d.getSeconds()).toString().padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}T${hours}:${minutes}:${sec}`;
  },
}